module.exports = __webpack_public_path__ + "img/about_model.afc28e64.svg";